import type { OnboardingStepConfig, OptionItem } from './types';

// ─── Pasos del onboarding ─────────────────────────────────────────────────────

export const ONBOARDING_STEPS: OnboardingStepConfig[] = [
    { id: 'usage', title: '¿Para qué vas a utilizar Khronox?' },
    { id: 'manage', title: '¿Qué te gustaría gestionar?', optional: true },
    { id: 'orgName', title: '¿Cómo te gustaría llamar tu primera organización?', optional: true },
    { id: 'features', title: '¿Qué funciones te gustaría probar?', optional: true },
    { id: 'taskOrganization', title: '¿Cómo quieres organizar tus tareas?', optional: true },
    { id: 'inviteMembers', title: 'Invita a colaboradores a tu organización:', optional: true },
];

// ─── Opciones por paso ────────────────────────────────────────────────────────
// Llena las opciones de cada paso con los valores correctos

export const USAGE_OPTIONS: OptionItem[] = [
    { id: 'personal', label: 'Uso personal' },
    { id: 'team', label: 'Equipo pequeño' },
    { id: 'company', label: 'Empresa' },
    { id: 'freelance', label: 'Freelance' },
    // agrega más opciones aquí
];

export const MANAGE_OPTIONS: OptionItem[] = [
    { id: 'projects', label: 'Proyectos' },
    { id: 'tasks', label: 'Tareas' },
    { id: 'team', label: 'Equipo' },
    { id: 'clients', label: 'Clientes' },
    // agrega más opciones aquí
];

export const FEATURES_OPTIONS: OptionItem[] = [
    { id: 'tasks', label: 'Tareas y proyectos' },
    { id: 'automations', label: 'Automatizaciones' },
    { id: 'goals', label: 'Metas' },
    { id: 'chat', label: 'Chat' },
    { id: 'sprints', label: 'Sprints' },
    { id: 'docs', label: 'Documentos' },
    { id: 'calendar', label: 'Calendario' },
    { id: 'crm', label: 'CRM' },
    { id: 'gantt', label: 'Cronogramas' },
    { id: 'flowchart', label: 'Diagramas de flujo' },
    { id: 'time', label: 'Registro de tiempo' },
    { id: 'forms', label: 'Formularios' },
    { id: 'workload', label: 'Carga de trabajo' },
    { id: 'ai', label: 'IA' },
];

export const TASK_ORGANIZATION_OPTIONS: OptionItem[] = [
    { id: 'board', label: 'Tablero Kanban' },
    { id: 'list', label: 'Lista' },
    { id: 'calendar', label: 'Calendario' },
    { id: 'gantt', label: 'Gantt' },
    // agrega más opciones aquí
];